import { render, staticRenderFns } from "./MypagePointHistoryPane.vue?vue&type=template&id=65811d78&scoped=true"
import script from "./MypagePointHistoryPane.vue?vue&type=script&lang=ts"
export * from "./MypagePointHistoryPane.vue?vue&type=script&lang=ts"
import style0 from "./MypagePointHistoryPane.vue?vue&type=style&index=0&id=65811d78&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65811d78",
  null
  
)

export default component.exports